import React, { useMemo } from "react";
import { getVisibleBulkCommissionActions } from "./commissionBulkActionCatalog";
import { buildBulkActionMenuItems } from "./commissionBulkActionMenuItems";
import CommissionsRowActionsToolbar from "./CommissionsRowActionsToolbar";

function CommissionsBulkActions({
  selectedApplications = [],
  commissionView = "active",
  activeReport = "commission",
  loading = false,
  onRunAction,
}) {
  const actions = useMemo(
    () =>
      getVisibleBulkCommissionActions({
        commissionView,
        activeReport,
        selectedApplications,
      }),
    [commissionView, activeReport, selectedApplications],
  );

  const selectedCount = selectedApplications.length;

  const menuItems = useMemo(
    () =>
      buildBulkActionMenuItems(actions, {
        loading,
        onRunAction,
        selectedCount,
      }),
    [actions, loading, onRunAction, selectedCount],
  );

  const hasEligibleAction = actions.some((action) => action.eligibleCount > 0);

  if (
    !actions.length ||
    selectedApplications.length === 0 ||
    !hasEligibleAction
  ) {
    return null;
  }

  return (
    <CommissionsRowActionsToolbar
      items={menuItems}
      disabled={loading}
      ariaLabel="Bulk commission workflow actions"
      triggerMode="labeled"
      triggerLabel={`Bulk actions (${selectedCount})`}
      menuTitle={`${selectedCount} selected`}
      openOnHover
      toolbarClassName="cms-commissions-row-actions--toolbar cms-commissions-bulk-actions"
      menuWidth={272}
    />
  );
}

export default CommissionsBulkActions;
